import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AttributeSection from "./components/AttributeSection";
import VariantSection from "./components/VariantSection";
import Select from "components/ui/Select";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategoriesService,
  getCategoryByIdService,
} from "redux/services/categories_service";
import ProductImageUpload from "./components/ProductImageUpload";
import Button from "components/ui/Button"; // تأكد من استيراد الزر من المسار الصحيح
import {
  createProductService,
  getAllProductsService,
  updateProductService,
} from "redux/services/products_sevice";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const allowedWeights = ["0.25", "0.50", "1", "2"];

const EditProduct = ({}) => {
  const { t } = useTranslation();

  const { productInfo } = useSelector((state) => state.products);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoadingAction } = useSelector((state) => state.products);
  const { categoryList, subCategories } = useSelector(
    (state) => state.categories,
  );
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    category_id: productInfo?.category?.id,
    subcategory_id: productInfo?.category_id,

    is_special: false,
    images: [],
    translations: {
      ar: { name: "", desc: "" },
    },

    hasAttributes: false,
    options: [{ id: null, weight: "", price: "", quantity: "" }],
  });

  // ملء formData ببيانات productInfo لما يتوفر
  useEffect(() => {
    if (productInfo) {
      // تحويل الصور: افترض إن productInfo.images هي مصفوفة من URLs، حولها إلى objects
      const images =
        productInfo.images?.map((img, index) => ({
          id: Date.now() + index, // ID مؤقت
          file: null, // مش هناك file جديد، بس URL
          url: img.url || img, // افترض إنها URL أو object
          name: `Image ${index + 1}`,
          size: 0, // مش مهم
          isPrimary: index === 0, // افترض الأول primary
        })) || [];

      setFormData({
        category_id:
          productInfo?.category?.parent_category !== null
            ? productInfo?.category?.parent_category?.id
            : productInfo?.category?.id,
        subcategory_id: productInfo?.category?.id,

        is_special: productInfo?.is_special || false,
        images,
        translations: productInfo.translations || {
          ar: { name: "", desc: "" },
        },
        options:
          productInfo?.options?.length > 0
            ? productInfo.options.map((opt) => ({
                id: opt.id,
                weight: opt.weight,
                price: opt.price,
                quantity: opt.quantity.toString(),
              }))
            : [{ id: null, weight: "", price: "", quantity: "" }],
      });
    }
  }, [productInfo, dispatch]);

  useEffect(() => {
    if (productInfo?.category?.parent_category?.id) {
      dispatch(getCategoryByIdService(productInfo.category.parent_category.id));
    }
  }, [productInfo, dispatch]);

  const handleInputChange = (field, value) => {
    if (field.includes("translations")) {
      const [lang, key] = field.split(".").slice(1);
      setFormData((prev) => ({
        ...prev,
        translations: {
          ...prev.translations,
          [lang]: { ...prev.translations[lang], [key]: value },
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  useEffect(() => {}, [formData, productInfo]);

  // ================= OPTIONS =================
  const handleOptionChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.options];
      updated[index][field] = value;
      return { ...prev, options: updated };
    });
  };

  const handleAddOption = () => {
    if (formData.options.length >= 4) return;
    setFormData((prev) => ({
      ...prev,
      options: [
        ...prev.options,
        { id: null, weight: "", price: "", quantity: "" },
      ],
    }));
  };

  const handleRemoveOption = (index) => {
    if (formData.options.length <= 1) return;
    setFormData((prev) => ({
      ...prev,
      options: prev.options.filter((_, i) => i !== index),
    }));
  };

  // ================= SUBMIT =================
  const handleSubmit = (e) => {
    e.preventDefault();

    const weights = formData.options.map((o) => o.weight);
    if (new Set(weights).size !== weights.length) {
      toast.warn("لا يمكن تكرار نفس الوزن");
      return;
    }

    for (let opt of formData.options) {
      if (!opt.weight || !opt.price || !opt.quantity) {
        toast.warn("جميع حقول الخيارات مطلوبة");
        return;
      }
    }

    console.log(formData);
    const formData2 = new FormData();

    formData2.append(
      "category_id",
      formData.subcategory_id !== null
        ? formData.subcategory_id
        : formData.category_id,
    );
    // formData2.append("subcategory_id", formData.subcategory_id);

    formData2.append("is_special", formData.is_special ? "1" : "0");

    // translations
    Object.keys(formData.translations).forEach((lang) => {
      Object.keys(formData.translations[lang]).forEach((key) => {
        formData2.append(
          `translations[${lang}][${key}]`,
          formData.translations[lang][key],
        );
      });
    });

    // images
    formData.images.forEach((im, index) => {
      if (im.file) {
        formData2.append(`images[${index + 1}]`, im.file);
      }
    });

    // options
    formData.options.forEach((option, index) => {
      if (option.id) {
        formData2.append(`options[${index}][id]`, option.id);
      }
      formData2.append(`options[${index}][weight]`, option.weight);
      formData2.append(`options[${index}][price]`, option.price);
      formData2.append(`options[${index}][quantity]`, option.quantity);
    });

    dispatch(
      updateProductService({ id: productInfo.id, formData: formData2 }),
    ).then((response) => {
      if (response?.payload?.status === 200) {
        toast.success(t("product_updated_success"));
        dispatch(getAllProductsService({ page: 1 }));
        navigate("/product-catalog-management");
      }
    });
  };

  useEffect(() => {
    dispatch(getAllCategoriesService({ page: 1 }));
  }, [dispatch]);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">{t("edit_product_title")}</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Basic Information Section */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">
            {t("basic_information")}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="category"
                className="block text-sm font-semibold text-gray-800 mb-2"
              >
                {t("category_label")}
              </label>
              <Select
                name="category_id"
                value={formData.category_id}
                onChange={(value) => {
                  dispatch(getCategoryByIdService(value));

                  handleInputChange("category_id", value);
                  handleInputChange("subcategory_id", null);
                }}
                options={categoryList.map((category) => ({
                  value: category.id,
                  label: category?.translations?.ar?.name,
                }))}
                placeholder={t("select_category_placeholder")}
                required
              />
            </div>

            <div>
              <label
                htmlFor="category"
                className="block text-sm font-semibold text-gray-800 mb-2"
              >
                {t("subCategoriesOf")}
              </label>
              <Select
                name="subcategory_id"
                value={formData.subcategory_id}
                onChange={(value) => handleInputChange("subcategory_id", value)}
                options={subCategories.map((category) => ({
                  value: category.id,
                  label: category?.translations?.ar?.name,
                }))}
                placeholder={t("select_subcategory_placeholder")}
                //  required
              />
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="is_special"
                checked={formData.is_special}
                onChange={(e) =>
                  handleInputChange("is_special", e.target.checked)
                }
                className="mr-2"
              />
              <label htmlFor="is_special" className="text-sm font-medium">
                {t("is_special_label")}
              </label>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium mb-1">
                {t("product_name_ar")}
              </label>
              <input
                type="text"
                value={formData.translations.ar.name}
                onChange={(e) =>
                  handleInputChange("translations.ar.name", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                {t("description_ar")}
              </label>
              <textarea
                value={formData.translations.ar.desc}
                onChange={(e) =>
                  handleInputChange("translations.ar.desc", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                rows={3}
              />
            </div>
          </div>
        </div>

        {/* Product Images Section */}
        <ProductImageUpload
          images={formData.images}
          onChange={(images) => handleInputChange("images", images)}
        />

        {/* OPTIONS */}
        <div className="bg-white p-6 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">خيارات المنتج</h2>

          {formData.options.map((option, index) => {
            const usedWeights = formData.options.map((o) => o.weight);

            return (
              <div key={index} className="grid md:grid-cols-4 gap-4 mb-4">
                <select
                  value={option.weight}
                  onChange={(e) =>
                    handleOptionChange(index, "weight", e.target.value)
                  }
                  className="border px-3 py-2 rounded"
                >
                  <option value="">اختر الوزن</option>
                  {allowedWeights.map((w) => (
                    <option
                      key={w}
                      value={w}
                      disabled={usedWeights.includes(w) && option.weight !== w}
                    >
                      {w} Kg
                    </option>
                  ))}
                </select>

                <input
                  type="number"
                  placeholder="السعر"
                  value={option.price}
                  onChange={(e) =>
                    handleOptionChange(index, "price", e.target.value)
                  }
                  className="border px-3 py-2 rounded"
                />

                <input
                  type="number"
                  placeholder="الكمية"
                  value={option.quantity}
                  onChange={(e) =>
                    handleOptionChange(index, "quantity", e.target.value)
                  }
                  className="border px-3 py-2 rounded"
                />

                {formData.options.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveOption(index)}
                    className="bg-red-500 text-white rounded px-3"
                  >
                    حذف
                  </button>
                )}
              </div>
            );
          })}

          {formData.options.length < 4 && (
            <button
              type="button"
              onClick={handleAddOption}
              className="bg-gray-200 px-4 py-2 rounded"
            >
              إضافة خيار
            </button>
          )}
        </div>

        {/* Form Actions */}
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mr-2 ml-2 px-4 py-2 border rounded hover:bg-gray-100"
          >
            {t("cancel_button")}
          </button>
          <Button
            type="submit"
            disabled={isLoadingAction}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-400"
          >
            {isLoadingAction ? t("is_loading") : t("update")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditProduct;
